import invariant from 'react-utils/invariant';
export const verifyReferenceType = referenceType => invariant(referenceType && typeof referenceType === 'string', 'expected `referenceType` to be a non-empty string');